module.exports = __webpack_public_path__ + "static/media/recycling_48.7c880a9b.png";